import script from "./Course.vue?vue&type=script&lang=ts&setup=true"
export * from "./Course.vue?vue&type=script&lang=ts&setup=true"

import "./Course.vue?vue&type=style&index=0&id=5269fd98&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5269fd98"]])

export default __exports__